"use strict";
import { loadStripe } from "@stripe/stripe-js";
export * from "../src/stripe/sta_stripe_payment_form";
window.loadStripe = loadStripe;
